import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkCdnUserListParamsRawI,
	type LWApiPublicNetworkCdnUserListResultRawI,
} from '@liquidweb-dev/club-sauce/public/network/cdn/user.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_CDN_USER_LIST_QUERY_KEY = '/network/cdn/user/list';

const useNetworkCdnUserList = (
	params: LWApiPublicNetworkCdnUserListParamsRawI,
	options?: UseQueryOptions<LWApiPublicNetworkCdnUserListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [NETWORK_CDN_USER_LIST_QUERY_KEY, params],
		queryFn: () => api.network.cdn.user.apiRaw.list(params),
		...options,
	});

export default useNetworkCdnUserList;
